import React from "react";

import { Stack } from "../Stack";
import { Container, RadioButton, SectionTitle } from "./styled";
import { Option } from "./types";

/**
 * Currently a horizontal list - please remove this comment, once you extend the implementation
 */

export interface RadioButtonListProps {
  id: string;
  title?: string;
  value?: string | undefined;
  options: Option[];
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  width?: string;
  disabled?: boolean;
}

export const RadioButtonList = ({
  id,
  title,
  options,
  value,
  onChange,
  width = "42%",
  disabled = false,
}: RadioButtonListProps) => {
  return (
    <>
      {title && <SectionTitle>{title}</SectionTitle>}
      <>
        <Stack width={width} justifyContent="space-between" direction="row">
          {options.map((option: Option, index) => (
            <Container key={`${index}-choice-${id}`}>
              <RadioButton
                type="radio"
                id={`${option.label}-option`}
                value={option.value}
                name={id}
                checked={value === option.value}
                onChange={onChange}
                disabled={disabled}
              />
              <>{option.label}</>
            </Container>
          ))}
        </Stack>
      </>
    </>
  );
};
